import React from 'react';
import Header from '../Common/Header';
import Footer from '../Common/Footer';

const Layout = ({ children }) => {
  return (
    <>
      <style>{`
        .layout-container {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
        }
        
        .layout-main {
          padding-top: 80px;
          padding-bottom: 40px;
          flex: 1;
        }
        
        @media (max-width: 768px) {
          .layout-main {
            padding-top: 70px;
            padding-bottom: 24px;
          }
        }
      `}</style>

      <div className="layout-container">
        <Header />
        <main className="layout-main">
          <div className="container">
            {children}
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Layout;
